import { useEffect, useState } from "react";
import {
  fetchSalesIndividualKpis,
  SalesIndividualFilterParams,
  SalesIndividualKpiResponse,
} from "../services/salesIndividualDashboardApi";

interface SalesIndividualKpiState {
  data: SalesIndividualKpiResponse | null;
  isLoading: boolean;
  error: string | null;
}

const getErrorMessage = (error: unknown): string => {
  if (error instanceof Error) return error.message;
  return "Failed to load Sales KPIs.";
};

export const useSalesIndividualKpis = (
  filters: SalesIndividualFilterParams,
  enabled: boolean,
  refreshKey = 0,
): SalesIndividualKpiState => {
  const [state, setState] = useState<SalesIndividualKpiState>({
    data: null,
    isLoading: false,
    error: null,
  });

  useEffect(() => {
    if (!enabled) return;
    if (filters.period === "custom" && (!filters.from_date || !filters.to_date)) {
      return;
    }

    let isCurrent = true;

    setState((current) => ({
      ...current,
      isLoading: true,
      error: null,
    }));

    fetchSalesIndividualKpis(filters)
      .then((data) => {
        if (!isCurrent) return;
        setState({ data, isLoading: false, error: null });
      })
      .catch((error) => {
        if (!isCurrent) return;
        setState((current) => ({
          ...current,
          isLoading: false,
          error: getErrorMessage(error),
        }));
      });

    return () => {
      isCurrent = false;
    };
  }, [enabled, filters.period, filters.from_date, filters.to_date, refreshKey]);

  return state;
};
